

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function AgentActivityDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BACKEND_LOCAL_API
      : process.env.REACT_APP_BACKEND_LIVE_API;

  const fetchData = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}agent/activity/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        },
      })
      .then((res) => setData(res.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  if (!data)
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" />
      </div>
    );

  const { allData, todayData, rangeData } = data;

  const AmountRow = ({ label, value, color }) => (
    <li className="list-group-item d-flex justify-content-between">
      <span>{label}</span>
      <span className={`fw-bold text-${color}`}>₹{value || 0}</span>
    </li>
  );

  return (
    <div className="container my-4">
      {/* HEADER */}
      <div className="card shadow-sm mb-4 border-0">
        <div className="card-body">
          <h4 className="fw-bold">Agent / Admin Activity</h4>
          <span className="badge bg-secondary">User ID: {id}</span>
        </div>
      </div>

      {/* DATE FILTER */}
      <div className="card shadow-sm mb-4 border-0">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">Start Date</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">End Date</label>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className="col-md-4 d-flex align-items-end">
              <button
                className="btn btn-primary w-100"
                onClick={fetchData}
                disabled={loading}
              >
                {loading ? "Loading..." : "Apply Filter"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* DATA CARDS */}
      <div className="row g-4">
         {/* FILTERED */}
        {rangeData && (
          <div className="col-md-4">
            <div className="card shadow-sm h-100 border-success">
              <div className="card-header bg-dark text-white">
                Selected Date Range
              </div>
              <ul className="list-group list-group-flush">
                <AmountRow label="Deposit" value={rangeData.deposit} color="success" />
                <AmountRow label="Withdraw" value={rangeData.withdraw} color="danger" />
                <AmountRow label="Bonus" value={rangeData.bonus} color="info" />
                <AmountRow label="Penalty" value={rangeData.penalty} color="warning" />
              </ul>
            </div>
          </div>
        )}
        {/* ALL TIME */}
        <div className="col-md-4">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-primary text-white">All Time</div>
            <ul className="list-group list-group-flush">
              <AmountRow label="Deposit" value={allData.totalDeposit} color="success" />
              <AmountRow label="Withdraw" value={allData.totalWithdraw} color="danger" />
              <AmountRow label="Bonus" value={allData.totalBonus} color="info" />
              <AmountRow label="Penalty" value={allData.totalPenalty} color="warning" />
            </ul>
          </div>
        </div>

        {/* TODAY */}
        <div className="col-md-4">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-success text-white">Today</div>
            <ul className="list-group list-group-flush">
              <AmountRow label="Deposit" value={todayData.todayDeposit} color="success" />
              <AmountRow label="Withdraw" value={todayData.todayWithdraw} color="danger" />
              <AmountRow label="Bonus" value={todayData.todayBonus} color="info" />
              <AmountRow label="Penalty" value={todayData.todayPenalty} color="warning" />
            </ul>
          </div>
        </div>

       
      </div>
    </div>
  );
}

